export default {
  state: {
    environment: null,
  },
  getters: {
    environment: state => state.environment,
    isProduction: state => state.environment === 'production',
  },
  mutations: {
    SET_ENVIRONMENT(state, payload) {
      state.environment = payload
    },
  },
  actions: {
    setEnvironment({ commit }, payload) {
      commit('SET_ENVIRONMENT', payload)
    },
  },
}
